export enum ImportStateEnum {
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  CRITICAL = "CRITICAL",
  UNKNOWN = "UNKNOWN",
}
